module.exports = __webpack_public_path__ + "img/saba_maatafa_no.082014b5.png";